import {Spin} from "antd"
import React, {useEffect, useState} from "react"
import {calendarService} from "services"
import {CreateEvent, ListEvents} from "./parts"
import styles from "./StudentInfoCalendarPanel.module.css"
import {Auth} from "types/auth"
import {useMyLinkedCalendars} from "hooks"

type DisplayPart = "list" | "create"

type Props = {
    displayPart?: DisplayPart
    departmentId?: number
    student?: Auth.DepartmentStudent
    onClose?: () => void
}

export const StudentInfoCalendarPanel = (props: Props) => {
    const {onClose, displayPart = "list", student} = props
    const [displayMode, setDisplayMode] = useState<DisplayPart>(displayPart)
    const [selectedDate, setSelectedDate] = useState<Date | null>(null)
    const [calendarId, setCalendarId] = useState(null)
    const {linkedCalendars} = useMyLinkedCalendars()

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        const {data} = await calendarService.getMyPrimaryCalendar({}, {})
        const {calendar_id} = data
        setCalendarId(calendar_id)
    }

    const onNavigate = (_displayMode: DisplayPart) => {
        setDisplayMode(_displayMode)
    }

    if (!calendarId) {
        return (
            <div className={styles.loading}>
                <Spin />
            </div>
        )
    }

    return (
        <>
            {displayMode === "list" ? (
                <ListEvents
                    onNavigate={onNavigate}
                    onClose={onClose}
                    departmentId={props.departmentId}
                    student={student}
                    onSelectedDayChange={setSelectedDate}
                    selectedDay={selectedDate}
                />
            ) : (
                <CreateEvent
                    calendarId={calendarId}
                    student={student}
                    selectedDate={selectedDate}
                    linkedCalendars={linkedCalendars}
                    onNavigate={onNavigate}
                />
            )}
        </>
    )
}
